// ─── Character type + legacy stub ──────────────────────────────────
// CharacterDef + CHARACTERS are still imported live by engine.ts, types.ts,
// WeaponLabScreen and GameCanvas. BETA 22.75 — BG_IMAGES removed: its only
// consumer was the deleted old-menu CharacterSelect.tsx.
export interface CharacterDef {
  id: string;
  name: string;
  url: string;
  description: string;
}

export const CHARACTERS: CharacterDef[] = [
  {
    id: 'killa',
    name: 'KILLA',
    url: '/cdn/killa_f3f58ae2.png',
    description: 'No mercy. No survivors.',
  },
];
